define('mailsMailHeaderLabelsAddView',[
  'app',
  'backbone',
  'module',
  'underscore',
  'modalsConfirmationView',
  'mailsMailHeaderLabelsAddDatalistView',
  'template!mailsMailHeaderLabelsAddView',
  'settings'
], function(
  App,
  Backbone,
  Module,
  _,
  ModalsConfirmationView,
  DatalistView,
  Tpl,
  Settings
) {
  'use strict';

  Module.exports = ModalsConfirmationView.extend({
    template: Tpl,
    className: 'mails-mail-labels-add-view ' + ModalsConfirmationView.prototype.className,

    ui: _.extend({  
      input: 'input'
    }, ModalsConfirmationView.prototype.ui),

    events: _.extend({  
      'change @ui.input': 'onFolderChange'
    }, ModalsConfirmationView.prototype.events),

    regions:  _.extend({   
      footer: '.footer',
      mailsLabelsRegion: '.mails-labels-region'
    }, ModalsConfirmationView.prototype.regions),

    initialize: function() {
      this.collection = new Backbone.Collection();
    },

    serializeData: function() {
      return {
        id: this.options.mailSecId     
      };
    },

    fetch: function (node, cb) {
      if(!this.options.mailSecId) {
        // Try to get mailSecId from another source, like a cookie
        var cookieMailSecId = Settings.get('currentMailSecIdCookie', true);
        if (cookieMailSecId) {
          this.options.mailSecId = cookieMailSecId;
        } else {
          cb([]);
          return;
        }
      }

      var params = {};
      params.folder = 'all';

      if(this.fetchRequest)
        this.fetchRequest.abort();

      this.fetchRequest = $.ajax({
        type: 'GET',
        url:  App.request('mails:get-folders-url', this.options.mailSecId, params),
        headers: {
          'Cache-Control': 'no-cache'
        },
        success: _.bind(function (items) {
          var mailLabels = this.model.get('labels');
          _.each(items, _.bind(function(item) {

            // If item is not yet in the list by comparing the id field, add it
            if (!_.find(mailLabels, { id: item.id })) {
              this.collection.push({
                  id: item.id,
                  value: item.fullName,
                  fullName: item.fullName,
                  name: item.name,
                  backgroundColor: item.backgroundColor,
                  textColor: item.textColor
                });
            }
          }, this));
        }, this)
      });
    },

    onShow: function () {
      // Use the SelectView to build a <select> HTML tag with <option> based on this.collection
      this.datalistView = new DatalistView({
        id: 'mails-labels-' + this.options.mailSecId,
        collection: this.collection
      });

      // Inject the view in the region
      this.getRegion('mailsLabelsRegion').show(this.datalistView);
      this.datalistView.on('change', _.bind(this.onFolderChange, this));

      // Trigger the AJAX call
      this.fetch();

      // Continue with parent's view onShow
      ModalsConfirmationView.prototype.onShow.apply(this, arguments);
    },

    onFolderChange: function () {
      

     /* var selectedFolder = {
        id: model.get('id'),
        name: model.get('name'),
        backgroundColor: model.get('backgroundColor'),
        textColor: model.get('textColor')
      };
      this.model.set('selectedFolder', selectedFolder);*/
    },

    onConfirm: function () {

      var fullName = this.ui.input.val();

      var selectdeModel = null;    
      _.each(this.collection.models, function (m) {
        if (m.get('fullName') === fullName)
          selectdeModel = m;
      }, this);

      if(selectdeModel) {
        this.model.addLabel(this.options.mailSecId, this.model.get('folder'), selectdeModel.toJSON()).done(_.bind(function() {
            var currentLabels = this.model.get('labels');
            var labels = currentLabels ? currentLabels.slice() : [];
            labels.push(selectdeModel.toJSON());
            this.model.set('labels', labels);          
        }, this));
      }
      this.windowView.close();
    },

    // Static methods
    open: function (data) {
      require([
        'windows',
        'mailsMailHeaderLabelsAddView'
      ], function (Windows, View) {
        Windows.open({
          view: _.bind(function () {
            return new View(data);
          }, this),
          modal: true,
          width: 400,
          maxWidth: 800,
          title: _.i18n('mails.labels.add')
        });
      });
    }
  });
});
